import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { APIService } from 'src/app/core/api/general.service';
import { GenericError } from 'src/app/layout/actions/layout.actions';
import { remarksActions } from '../actions';

@Injectable()
export class RemarksEffects {
  constructor(private actions$: Actions, private generalservice: APIService) {}

  saveRemarks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(remarksActions.SaveRemarksFromComponent),
      map((action) => {
        return remarksActions.SaveRemarksFromComponentSuccess({
          remarksResult: action.remarksInfo
        });
      }),
      catchError((response) => {
        return of(GenericError({ error: response.error }));
      })
    )
  );

  createRemarks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(remarksActions.CreateRemarksFromComponent),
      mergeMap((action) =>
        this.generalservice.createRemarks(action.remarksInfo, action.pnr).pipe(
          map((resp) =>
            remarksActions.CreateRemarksFromComponentSuccess({
              remarksResult: 'remarks created correctly',
              savedFromProccess: action?.savedFromProccess
            })
          ),
          catchError((response) => {
            return of(GenericError({ error: response.error }));
          })
        )
      )
    )
  );
}
